import { createTheme } from '@mui/material/styles';
import { createThemeFromFigma } from './figmaOrganizedTokens';

// Create themes from Figma tokens
export const lightTheme = createTheme(createThemeFromFigma('light'));
export const darkTheme = createTheme(createThemeFromFigma('dark'));

// Export light theme as default
export default lightTheme;
